import { action, makeObservable, observable } from 'mobx';

class LoadingStore {
  progress: number = 0;
  isAllResourceLoaded: boolean = false;

  constructor() {
    makeObservable(this, {
      progress: observable,
      isAllResourceLoaded: observable,
      setProgress: action.bound,
      simulateProgress: action.bound,
      setIsAllResourceLoaded: action.bound,
    });
  };

  setIsAllResourceLoaded = () => {
    this.isAllResourceLoaded = true;
  };

  simulateProgress = async (newValue: number) => {
    for (let i = this.progress; i <= newValue; i += 1) {
      this.updateProgress(i);
      await new Promise((resolve) => setTimeout(resolve, 20));
    };
  };

  updateProgress = (newValue: number) => {
    this.setProgress(newValue);
    Math.ceil(this.progress) === 100 && this.setIsAllResourceLoaded();
  };

  setProgress = (progressValue: number) => {
    this.progress = progressValue;
  };

  setGameResourcesLoaded = async () => {
    this.simulateProgress(30);
  }
  setGameConnectionOpen = () => {
    this.simulateProgress(50)
  }
  setJackpotConnectionOpen = () => {
    this.simulateProgress(80)
  }
  setEndLoadingProcess = async () => {
    this.simulateProgress(100);
  }
};

export const loadingStore = new LoadingStore();
